import {
  Button,
  Flex,
  Icon,
  InputItem,
  List,
  NavBar,
  Picker,
  Toast,
} from "antd-mobile";
import { createRef, useCallback, useEffect, useRef, useState } from "react";
import instance from "../../../../util/axios";
import "../index.css";
import { formatNumber } from "../util";
import NumberInputCell from "./NumberInput";

export interface ProductInfo {
  product: string[];
  productName: string;
  originalPrice: string;
  guidePrice: string;
  name?: string;
  count: number;
  gift?: string[];
  giftPurchasePrice?: string;
  giftCostPrice?: string;
  giftAccountingPrice?: string;
  subtotal: string;
  discount: string;
  receipts: string;
  earnings: string;
  coefficient?: string;
  sales: string;
}

interface twoProps {
  defaultValues?: ProductInfo[];
  userId: string;
  onCancel?: () => void;
  onOk?: (data: ProductInfo[], userArea: string, userAreaName: string) => void;
}
interface Option {
  label: string;
  value: string;
  children: any[];
}

const isIPhone = new RegExp("\\biPhone\\b|\\biPod\\b", "i").test(
  window.navigator.userAgent
);
let moneyKeyboardWrapProps: object | undefined;
if (isIPhone) {
  moneyKeyboardWrapProps = {
    onTouchStart: (e: { preventDefault: () => any }) => e.preventDefault(),
  };
}

const StepTwo = ({ onCancel, onOk, defaultValues, userId }: twoProps) => {
  const countRef = useRef<any[]>([]);
  const orderInfoRef = useRef<any>(null);
  const [orderInfo, setOrderInfo] = useState<ProductInfo[]>([
    {
      product: [],
      productName: "",
      originalPrice: "",
      name: "",
      guidePrice: "",
      count: 1,
      gift: [],
      giftPurchasePrice: "",
      giftCostPrice: "",
      giftAccountingPrice: "",
      subtotal: "",
      discount: "",
      receipts: "",
      earnings: "",
      coefficient: "",
      sales: "",
    },
  ]);
  const [productOptions, setProductOptions] = useState<Option[]>([]);
  const [giftOptions, setGiftOptions] = useState<Option[]>([]);

  const [editablePrice, setEditablePrice] = useState<boolean>(false);
  const [editableGift, setEditableGift] = useState<boolean>(false);
  const [editGiftPurchase, setEditGiftPurchase] = useState<boolean>(false);
  const [editGiftCost, setEditGiftCost] = useState<boolean>(false);
  const [userArea, setUserArea] = useState("");

  useEffect(() => {
    if (defaultValues && defaultValues.length > 0) {
      setOrderInfo(defaultValues);
    }
  }, [defaultValues]);

  useEffect(() => {
    instance
      .get(`/custom/enterprise/zhengbao/order/getPsiSkuCategoryAndSku`)
      .then((resp) => {
        if (resp.data.Status === "1") {
          const data = resp.data.Data;
          setProductOptions(
            data.filter(
              (item: { value: string }) =>
                item.value !== "5d260a7cf9a244518a7f16853c234e1a"
            )
          );
          setGiftOptions(
            data.filter(
              (item: { value: string }) =>
                item.value === "5d260a7cf9a244518a7f16853c234e1a"
            )
          );
        }
      });
  }, []);

  useEffect(() => {
    (async function () {
      let area = "";
      const resp1 = await instance.post(`/wf/form/vsheet/rpc`, {
        method: "getCityBranch",
        workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
        paramsJson: JSON.stringify({ advisorId: userId }),
      });
      if (!resp1.data.Data) {
        const resp2 = await instance.post(`/wf/form/vsheet/rpc`, {
          method: "getProvincialBranch",
          workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
          paramsJson: JSON.stringify({ advisorId: userId }),
        });
        if (!resp2.data.Data) {
          const resp3 = await instance.post(`/wf/form/vsheet/rpc`, {
            method: "getRegion",
            workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
            paramsJson: JSON.stringify({ advisorId: userId }),
          });
          if (!resp3.data.Data) {
            area = "f90c2eb73c9c4142af1b1a11f027624e";
          } else {
            area = resp3.data.Data;
          }
        } else {
          area = resp2.data.Data;
        }
      } else {
        area = resp1.data.Data;
      }
      setUserArea(area);
    })();
  }, [userId]);

  const addProduct = useCallback(() => {
    const newData = JSON.parse(JSON.stringify(orderInfo));
    newData.push({
      product: [],
      productName: "",
      originalPrice: "",
      name: "",
      guidePrice: "",
      count: 1,
      gift: [],
      giftPurchasePrice: "",
      giftCostPrice: "",
      giftAccountingPrice: "",
      subtotal: "",
      discount: "",
      receipts: "",
      earnings: "",
      coefficient: "",
      sales: "",
    });
    setOrderInfo(newData);
  }, [orderInfo]);

  const delProduct = useCallback(
    (index) => {
      const newData = JSON.parse(JSON.stringify(orderInfo));
      newData.splice(index, 1);
      setOrderInfo(newData);
    },
    [orderInfo]
  );

  const onChangeProduct = useCallback(
    (val, index) => {
      let copy = JSON.parse(JSON.stringify(orderInfo));

      instance
        .post(`/wf/form/vsheet/rpc`, {
          method: "getPsiSkuInfo",
          workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
          paramsJson: JSON.stringify({ uuid: val[2] }),
        })
        .then((resp) => {
          if (resp.data.Status === "1") {
            copy[index].product = val;
            copy[index].originalPrice = resp.data.Data[0].price || 0 + "";
            copy[index].guidePrice =
              resp.data.Data[0].custom_number_02 || 0 + "";
            const count = countRef.current[index]?.getValue() || 1;
            copy[index].subtotal = count * resp.data.Data[0].price || 0 + "";
            const firstCategory: any = productOptions.find(
              (item) => item.value === val[0]
            );
            const secondCategory = firstCategory.children.find(
              (item: { value: any }) => item.value === val[1]
            );
            const thirdCategory = secondCategory.children.find(
              (item: { value: any }) => item.value === val[2]
            );
            copy[index].productName = thirdCategory.label;
            copy[index].receipts = "0";
            setOrderInfo(copy);
            if (val[0] === "89d9cccbf5c044f6a9f9bb5d2fba9548") {
              setEditablePrice(false);
              setEditableGift(true);
              setEditGiftPurchase(true);
              setEditGiftCost(true);
            } else if (val[0] === "b9341b6affc14422b78e514d37ab61ef") {
              setEditablePrice(true);
              setEditableGift(false);
              setEditGiftPurchase(false);
              setEditGiftCost(false);
            }
          }
        });
    },
    [orderInfo, productOptions]
  );

  const onChangeGift = useCallback(
    (val, index) => {
      let copy = JSON.parse(JSON.stringify(orderInfo));
      instance
        .post(`/wf/form/vsheet/rpc`, {
          method: "getGiftPrice",
          workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
          paramsJson: JSON.stringify({ uuid: val[2] }),
        })
        .then((resp) => {
          if (resp.data.Status === "1") {
            copy[index].gift = val;
            copy[index].giftPurchasePrice = resp.data.Data[0].price || 0 + "";
            copy[index].giftCostPrice =
              resp.data.Data[0].custom_number_01 + "" || "0";
            copy[index].giftAccountingPrice =
              resp.data.Data[0].custom_number_03 + "" || "0";
            const count = countRef.current[index]?.getValue() || 1;
            copy[index].subtotal =
              parseFloat(copy[index].originalPrice) * count +
              resp.data.Data[0].custom_number_01 +
              "";
            copy[index].receipts = "0";
            setOrderInfo(copy);
            if (val[1] === "33775de6b9f64c2db9bc610f24a3d7f5") {
              setEditGiftPurchase(false);
              setEditGiftCost(true);
            } else {
              setEditGiftPurchase(true);
              setEditGiftCost(false);
            }
          }
        });
    },
    [orderInfo]
  );

  const onSave = useCallback(
    async (form: ProductInfo[]) => {
      if (form.length === 0) {
        Toast.info("请至少选择一种产品", 1);
        return;
      }
      let required: boolean = true;
      let validate: boolean = true;
      for (let i = 0; i < form.length; i++) {
        if (form[i].product.length === 0) {
          required = false;
          break;
        }
        if (
          form[i].product[0] !== "b9341b6affc14422b78e514d37ab61ef" &&
          (form[i].coefficient === "0" || form[i].sales === "0")
        ) {
          validate = false;
          break;
        }
      }
      if (!required) {
        Toast.info("请选择产品", 1);
        return;
      }
      if (!validate) {
        Toast.info("请联系总部业务支持,设置对应业绩系数", 1);
        return;
      }
      countRef.current?.forEach((ref, i) => {
        const val = ref?.getValue();
        form[i].count = val || 1;
      });
      const resp = await instance.get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=base_department&key=&selectId=&filter=&colName=&isFull=true`
      );
      if (resp.data.Status === "1") {
        if (userArea) {
          const areaName = resp.data.Data.find(
            (item: { uuid: string }) => item.uuid === userArea
          ).name;
          onOk?.(form, userArea, areaName);
        }
      }
    },
    [onOk, userArea]
  );

  useEffect(() => {
    const len = orderInfo.length;
    if (countRef.current.length !== len) {
      countRef.current = Array(len)
        .fill(null)
        .map((_, i) => countRef.current[i] || createRef());
    }
  }, [orderInfo.length, countRef]);

  useEffect(() => {
    orderInfoRef.current = orderInfo;
  }, [orderInfo]);

  return (
    <>
      <NavBar
        className="orderNavBar"
        icon={<Icon type="left" onClick={onCancel} />}>
        销售及内训订单
      </NavBar>
      <div className="mt45"></div>
      {orderInfo.length > 0 &&
        orderInfo.map((item, index) => (
          <div key={"item" + index}>
            <Flex
              justify="between"
              style={{ background: "#f2f2f2", padding: "10px 20px" }}>
              <Flex.Item>产品{index + 1}</Flex.Item>
              <Flex.Item style={{ textAlign: "right", color: "#999" }}>
                <Icon
                  type="cross-circle"
                  size={"xxs"}
                  onClick={() => delProduct(index)}
                />
              </Flex.Item>
            </Flex>
            <List className="picker-list">
              <Picker
                data={productOptions}
                cols={3}
                className="productPickerWrapper"
                value={item.product}
                onChange={(val: any) => onChangeProduct(val, index)}>
                <List.Item arrow="horizontal">
                  <span className="required">*</span>请选择产品
                </List.Item>
              </Picker>
              <InputItem
                placeholder="0.00"
                extra="元"
                disabled={!editablePrice}
                onChange={(value: any) => {
                  const count = countRef.current[index]?.getValue() || 1;
                  let copy = JSON.parse(JSON.stringify(orderInfo));
                  copy[index].originalPrice = formatNumber(value);
                  copy[index].subtotal =
                    count * parseFloat(formatNumber(value)) + "";
                  copy[index].receipts = "0";
                  setOrderInfo(copy);
                }}
                value={item.originalPrice}>
                产品原价
              </InputItem>
              <InputItem
                value={item.name}
                disabled={!editablePrice}
                onChange={(value) => {
                  let copy = JSON.parse(JSON.stringify(orderInfo));
                  copy[index].name = value;
                  setOrderInfo(copy);
                }}>
                课程名称
              </InputItem>
              <InputItem
                placeholder="0.00"
                extra="元"
                disabled={true}
                value={item.guidePrice}>
                销售指导价
              </InputItem>
              <Flex>
                <Flex.Item style={{ fontSize: 14, paddingLeft: 15 }}>
                  <span className="required">*</span>
                  <span
                    className={
                      item.product[1] === "6c2f89b5410640eaa394f8d3288709f7"
                        ? "disabledPicker"
                        : ""
                    }>
                    数量
                  </span>
                </Flex.Item>
                <Flex.Item>
                  <NumberInputCell
                    key={"numberInput" + index}
                    defaultvalue={1}
                    editable={
                      item.product[1] === "6c2f89b5410640eaa394f8d3288709f7"
                        ? false
                        : true
                    }
                    onChange={(value) => {
                      let copy = JSON.parse(
                        JSON.stringify(orderInfoRef.current)
                      );
                      copy[index].subtotal =
                        parseFloat(copy[index].originalPrice || 0) * value + "";
                      copy[index].receipts = "0";
                      setOrderInfo(copy);
                    }}
                    ref={(el) => (countRef.current[index] = el)}
                  />
                </Flex.Item>
              </Flex>
              <Picker
                data={giftOptions}
                cols={3}
                value={item.gift}
                className="giftPickerWrapper"
                disabled={!editableGift}
                onChange={(value: any) => {
                  onChangeGift(value, index);
                }}>
                <List.Item arrow="horizontal">
                  <span className={!editableGift ? "disabledPicker" : ""}>
                    请选择赠品
                  </span>
                </List.Item>
              </Picker>
              <InputItem
                placeholder="0.00"
                extra="元"
                type="money"
                moneyKeyboardWrapProps={moneyKeyboardWrapProps}
                disabled={!editGiftPurchase}
                value={item.giftPurchasePrice}
                onChange={(value: any) => {
                  let copy = JSON.parse(JSON.stringify(orderInfo));
                  copy[index].giftPurchasePrice = formatNumber(value);
                  copy[index].giftCostPrice = (
                    parseFloat(formatNumber(value) || "0") * 1.1
                  ).toFixed(2);
                  copy[index].giftAccountingPrice = (
                    parseFloat(formatNumber(value) || "0") * 1.1
                  ).toFixed(2);
                  copy[index].receipts = "0";
                  copy[index].earnings = (
                    parseFloat(copy[index].receipts || "0") -
                    parseFloat(formatNumber(value) || "0") * 1.1
                  ).toFixed(2);

                  setOrderInfo(copy);
                }}>
                赠品采购价
              </InputItem>
              <InputItem
                placeholder="0.00"
                extra="元"
                type="money"
                moneyKeyboardWrapProps={moneyKeyboardWrapProps}
                disabled={true}
                value={item.giftCostPrice}
                onChange={(value: any) => {
                  let copy = JSON.parse(JSON.stringify(orderInfo));
                  copy[index].giftCostPrice = formatNumber(value);
                  setOrderInfo(copy);
                }}>
                赠品含税成本价
              </InputItem>
              <InputItem
                placeholder="0.00"
                extra="元"
                type="money"
                moneyKeyboardWrapProps={moneyKeyboardWrapProps}
                disabled={!editGiftCost}
                value={item.giftAccountingPrice}
                onChange={(value: any) => {
                  let copy = JSON.parse(JSON.stringify(orderInfo));
                  copy[index].giftAccountingPrice = formatNumber(value);
                  copy[index].receipts = "0";
                  copy[index].earnings = (
                    parseFloat(copy[index].receipts || "0") -
                    parseFloat(formatNumber(value) || "0")
                  ).toFixed(2);
                  setOrderInfo(copy);
                }}>
                赠品内部核算价
              </InputItem>
              <InputItem
                placeholder="0.00"
                extra="元"
                type="money"
                disabled={true}
                value={item.subtotal}>
                应收小计
              </InputItem>
              <InputItem disabled={true} value={item.discount}>
                销售折扣
              </InputItem>
              <InputItem
                placeholder="0.00"
                extra="元"
                type="money"
                moneyKeyboardWrapProps={moneyKeyboardWrapProps}
                value={item.receipts}
                onBlur={async (value) => {
                  const resp4 = await instance.post(`/wf/form/vsheet/rpc`, {
                    method: "getNationWidePerformanceCoefficient",
                    workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
                    paramsJson: JSON.stringify({
                      skuId: orderInfo[index].product[2],
                      area: userArea,
                      salesDiscout: orderInfo[index].discount,
                    }),
                  });
                  let copy = JSON.parse(JSON.stringify(orderInfo));
                  if (resp4.data.Status === "1" && resp4.data.Data.length > 0) {
                    copy[index].coefficient = resp4.data.Data[0].coefficient;
                    copy[index].sales =
                      (parseFloat(resp4.data.Data[0].coefficient || "0") *
                        parseFloat(copy[index].earnings || "0")) /
                        100 +
                      "";
                  } else {
                    copy[index].coefficient = "0";
                    copy[index].sales = "0";
                  }
                  setOrderInfo(copy);
                }}
                onChange={(value: any) => {
                  let copy = JSON.parse(JSON.stringify(orderInfo));
                  copy[index].receipts = formatNumber(value);
                  copy[index].earnings = (
                    parseFloat(formatNumber(value) || "0") -
                    parseFloat(copy[index].giftAccountingPrice || "0")
                  ).toFixed(2);
                  copy[index].discount =
                    copy[index].originalPrice &&
                    copy[index].originalPrice !== "0"
                      ? (
                          (parseFloat(copy[index].earnings) /
                            parseFloat(copy[index].originalPrice)) *
                          100
                        ).toFixed(2) + ""
                      : "0";

                  setOrderInfo(copy);
                }}>
                <span className="redSpan">实收款</span>
              </InputItem>
              <InputItem
                placeholder="0.00"
                extra="元"
                disabled={true}
                value={item.earnings || "0"}>
                收入
              </InputItem>
              <InputItem disabled={true} value={item.coefficient}>
                业绩系数
              </InputItem>
              <InputItem
                placeholder="0.00"
                extra="元"
                disabled={true}
                value={item.sales}>
                销售业绩额
              </InputItem>
            </List>
          </div>
        ))}
      <div className="space"></div>
      <div className="addShopBtn" onClick={addProduct}>
        + 添加产品
      </div>
      <div className="space"></div>
      <Flex style={{ margin: "30px 0", padding: "0 30px" }}>
        <Flex.Item>
          <Button type="primary" onClick={onCancel}>
            上一步
          </Button>
        </Flex.Item>
        <Flex.Item>
          <Button type="primary" onClick={() => onSave(orderInfo)}>
            下一步
          </Button>
        </Flex.Item>
      </Flex>
    </>
  );
};

export default StepTwo;
